const stats = [
  { value: "24/7", label: "Technical Support" },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-white w-full">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative w-full h-[520px] rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/aee738dd632d8980cccc80f7e8b6295d.jpg"
              alt="MPIBERNIK d.o.o. development team"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            {/* Floating badge */}
            <div className="absolute bottom-6 left-6 bg-white rounded-xl px-5 py-3 shadow-md">
              <p className="text-xs text-gray-500 uppercase tracking-wide font-medium">Founded in</p>
              <p className="text-2xl font-bold text-gray-900">Slovenia</p>
            </div>
          </div>

          {/* Right: Text */}
          <div className="flex flex-col">
            <span className="text-emerald-500 text-sm font-semibold uppercase tracking-widest mb-3">
              About Us
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Who We Are
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-5">
              MPIBERNIK d.o.o. is a Slovenian software company composed of seasoned iOS engineers, security researchers, and UX designers. We specialize exclusively in the Apple ecosystem, dedicating every line of code to building apps that users trust and rely on daily.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-10">
              From conception to App Store deployment, our end-to-end process emphasizes performance, security, and elegant simplicity. Our flagship products — a high-performance VPN and an intelligent device Cleaner — reflect our commitment to delivering real value to iOS users around the world.
            </p>

            {/* Stats Grid */}
            <div className="flex">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-gray-50 rounded-xl p-5">
                  <p className="text-3xl font-extrabold text-gray-900">{stat.value}</p>
                  <p className="text-sm text-gray-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
